import { render, staticRenderFns } from "./OfertasEspeciais.vue?vue&type=template&id=692ab03a&"
import script from "./OfertasEspeciais.vue?vue&type=script&defer=true&lang=js&"
export * from "./OfertasEspeciais.vue?vue&type=script&defer=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports